module.exports = __webpack_public_path__ + "img/full7-min.f48ed185.png";